import React, {Component} from 'react'
import {connect} from 'react-redux'
import {FJTimeLineAction} from "../../../redux/action/FJRoot.action";
import FJTimeLineToolLeft  from 'fj-components/FJTimeLineToolLeft';
import key from 'keymaster'
import FJLocalStore from '../../../store/FJLocalStore';
import styles from '../css/FJTimelineToolLeftContainer.module.less';

import split from '../../../icon/split.svg'
import copy from '../../../icon/copy.svg'
import cut from '../../../icon/cut.svg'
import paste from '../../../icon/paste.svg'
import deletetool from '../../../icon/deletetool.svg'

class FJTimelineToolLeftContainer extends Component {

  componentDidMount() {
    key('ctrl+c, ⌘+c', 'default', this.copy);
    key('ctrl+v, ⌘+v', 'default', this.props.onPaste);
  }

  copy = (e) => {
    this.props.onCopy(this.props.selectedId);
  };

  render() {

    let {
      onClickDelete,
      onClickSplit,
      selectedId,
      couldPaste,
      couldCopy,
      onPaste,
      couldSplit
    } = this.props;

    let classes = {
      primaryClassName: styles.tool_left_btn,
      disabledClassName: styles.tool_left_btn_disabled,
      iconClassName: styles.icon,
      textClassName: styles.text,
    };

    let config = {
      splitIcon: split,
      copyIcon: copy,
      cutIcon: cut,
      pasteIcon: paste,
      deleteIcon: deletetool
    };

    return (
      <FJTimeLineToolLeft
        selectedId={selectedId}
        onClickDelete={onClickDelete}
        onClickSplit={onClickSplit}
        onClickCopy={this.copy}
        onClickPaste={onPaste}
        hasSplit={true}
        hasCopy={true}
        hasCut={false}
        hasPaste={true}
        hasDelete={true}
        couldSplit={couldSplit}
        couldCopy={couldCopy && selectedId !== -1}
        couldCut={true}
        couldPaste={couldPaste}
        couldDelete={selectedId !== -1}

        splitText={FJLocalStore._('split')}
        copyText={FJLocalStore._('copy')}
        cutText={FJLocalStore._('cut')}
        pasteText={FJLocalStore._('paste')}
        deleteText={FJLocalStore._('delete')}
        classes={classes}
        config={config}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedId: state.timeline.selectedId,
    couldCopy: state.copy.couldCopy,
    couldPaste: state.copy.couldPaste,
    duration:state.timeline.duration,
    couldSplit: state.timeline.couldSplit
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClickDelete: function (selectedId) {
      dispatch(FJTimeLineAction.deleteTimelineAction(selectedId));
    },
    onClickSplit: function (selectedId) {
      dispatch(FJTimeLineAction.splitTimelineAction(selectedId));
    },
    onCopy: function (selectedId) {
      dispatch(FJTimeLineAction.copyAction(selectedId));
    },
    onPaste: function () {
      dispatch(FJTimeLineAction.pasteAction());
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJTimelineToolLeftContainer);
